/* tslint:disable */
/* eslint-disable */
/**
 * B2B Air Price Watch
 * Endpoints needed to manage flight price watches
 *
 * The version of the OpenAPI document: v2p5
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

export interface Airline {
    'displayName': string;
    'customHashTag'?: string;
    'fullName': string;
    'isLcc': boolean;
    'webLinks': WebLinks;
    /**
     * 2 character IATA Airline code
     * @type {string}
     * @memberof Airline
     */
    'code': string;
    'cabinClassMappings': { [key: string]: HopperCabinClass; };
    'phone'?: string;
}
export interface Airport {
    'coordinates': Coordinates;
    'servedCityName': string;
    'name': string;
    /**
     *  The name of the metropolitan area generally associated with the airport    e.g. the YUL airport is in Dorval but should have cityName == \"Montreal\"    e.g. the EWL airport serves New York City but it\'s still treated as belonging to Newark, so cityName == \"Newark\"
     * @type {string}
     * @memberof Airport
     */
    'cityName': string;
    /**
     * 3 character IATA city code
     * @type {string}
     * @memberof Airport
     */
    'servedCity': string;
    /**
     * 3 character IATA Airport code
     * @type {string}
     * @memberof Airport
     */
    'code': string;
    'geography': GeopoliticalInfo;
    /**
     * military airports often place restrictions on international travelers
     * @type {boolean}
     * @memberof Airport
     */
    'military': boolean;
}
/**
 * When regionType is airport, code represents an IATA airport code and when regionType is city, code is an IATA city code
 * @export
 * @interface AirportRegion
 */
export interface AirportRegion {
    'regionType': RegionType;
    'code': string;
}


/**
 * @type AlertKey
 * @export
 */
export type AlertKey = { AlertKey: 'FlightKey' } & FlightKey;

export const AlertKeyEnum = {
    FlightKey: 'FlightKey'
} as const;

export type AlertKeyEnum = typeof AlertKeyEnum[keyof typeof AlertKeyEnum];


/**
 * A monetary amount
 * @export
 * @interface Amount
 */
export interface Amount {
    'amount': number;
    'currency': string;
}
export interface City {
    'coordinates': Coordinates;
    'name': string;
    /**
     * 3 character IATA city code
     * @type {string}
     * @memberof City
     */
    'code': string;
    'servingAirports': Array<Airport>;
    'geography': GeopoliticalInfo;
}
export interface Coordinates {
    'lat': number;
    'lon': number;
}
export interface CreateWatchAlertRequest {
    'key': AlertKey;
    'method': MessageMethod;
    'passengers': { [key: string]: number; };
}
export interface DeleteWatchAlertRequest {
    'key': AlertKey;
}
/**
 * A displayable monetary amount
 * @export
 * @interface DisplayAmount
 */
export interface DisplayAmount {
    'amount': Amount;
    'display': string;
}
export interface Email {
    /**
     * An email address that matches given regex pattern. The frontend should validate the emails address since the request will fail if it doesn\'t match the pattern
     * @type {string}
     * @memberof Email
     */
    'email': string;
    'MessageMethod'?: MessageMethodEnum;
}


export interface ErrorCode {
    'code': string;
    'details'?: string;
}
export interface Failure {
    'errors': Array<ErrorCode>;
    'Response': ResponseEnum;
}


export interface FlightAlertKey {
    'filter': ShopFilter;
    'origin': AirportRegion;
    'returnDate'?: string;
    'destination': AirportRegion;
    'departureDate': string;
}


export interface FlightKey {
    'value': FlightAlertKey;
    'AlertKey': AlertKeyEnum;
}


export interface GeopoliticalInfo {
    /**
     * 2 character country code
     * @type {string}
     * @memberof GeopoliticalInfo
     */
    'countryCode': string;
    'regionCode'?: string;
    'currency': string;
    'timeZone': string;
}
export interface GetWatchAlertDetailsRequest {
    'key': AlertKey;
}
export interface GetWatchAlertDetailsResponse {
    'predictionCopy'?: PredictionCopy;
    'pricePrediction': PricePrediction;
}
/**
 * @type GetWatchAlertDetailsResponseResponse
 * @export
 */
export type GetWatchAlertDetailsResponseResponse = { Response: 'Failure' } & Failure | { Response: 'Success' } & GetWatchAlertDetailsResponseSuccess;

export interface GetWatchAlertDetailsResponseSuccess {
    'value': GetWatchAlertDetailsResponse;
    'Response': ResponseEnum;
}


export const HopperCabinClass = {
    Business: 'Business',
    Economy: 'Economy',
    First: 'First',
    PremiumEconomy: 'PremiumEconomy',
    Unknown: 'Unknown'
} as const;

export type HopperCabinClass = typeof HopperCabinClass[keyof typeof HopperCabinClass];


export interface Interval {
    'dates': string;
    'copy': string;
}
export interface Intervals {
    'normal'?: Interval;
    'warning'?: Interval;
    'danger'?: Interval;
}
export interface IsEligible {
    'candidateId': string;
    'PriceDropProtection': PriceDropProtectionEnum;
    'trackingPropertiesV2': TrackingProperties;
    'maximumRefund': PriceDropMaximumRefund;
    'minimumRefund': PriceDropMinimumRefund;
    'monitoringDuration': PriceDropMonitoringDuration;
}


/**
 * @type MessageMethod
 * @export
 */
export type MessageMethod = { MessageMethod: 'Email' } & Email | { MessageMethod: 'MultiMethod' } & MultiMethod | { MessageMethod: 'Push' } & Push | { MessageMethod: 'Sms' } & Sms;

export const MessageMethodEnum = {
    Email: 'Email',
    MultiMethod: 'MultiMethod',
    Push: 'Push',
    Sms: 'Sms'
} as const;

export type MessageMethodEnum = typeof MessageMethodEnum[keyof typeof MessageMethodEnum];


export interface MultiMethod {
    'push'?: Push;
    'email'?: Email;
    'sms'?: Sms;
    'MessageMethod': MessageMethodEnum;
}


export interface NotEligible {
    'reason'?: string;
    'PriceDropProtection': PriceDropProtectionEnum;
}


export interface PredictionCopy {
    'recommendationBodyWatching': Array<string>;
    'carrier': string;
    'recommendationTitleWatching': Array<string>;
    'intervals': Intervals;
    'recommendationBody': Array<string>;
    'lowestPriceLabel': string;
    'recommendationTitleJustWatched': Array<string>;
    'lowestPrice': string;
    'recommendationBodyJustWatched': Array<string>;
    'travelDates': string;
    'origin': string;
    'recommendationTitle': Array<string>;
    'dealness': string;
    'destination': string;
}
export interface PriceDropMaximumRefund {
    'display': string;
    'amount': Amount;
}
export interface PriceDropMinimumRefund {
    'display': string;
    'amount': Amount;
}
export interface PriceDropMonitoringDuration {
    'inSeconds': number;
}
/**
 * @type PriceDropProtection
 * @export
 */
export type PriceDropProtection = { PriceDropProtection: 'IsEligible' } & IsEligible | { PriceDropProtection: 'NotEligible' } & NotEligible;

export const PriceDropProtectionEnum = {
    IsEligible: 'IsEligible',
    NotEligible: 'NotEligible'
} as const;

export type PriceDropProtectionEnum = typeof PriceDropProtectionEnum[keyof typeof PriceDropProtectionEnum];


export interface PricePrediction {
    'minPrice'?: DisplayAmount;
    'maxPrice'?: DisplayAmount;
}
export interface Push {
    'MessageMethod'?: MessageMethodEnum;
}


export const Recommendation = {
    Buy: 'Buy',
    Wait: 'Wait'
} as const;

export type Recommendation = typeof Recommendation[keyof typeof Recommendation];


export const RegionType = {
    airport: 'airport',
    city: 'city'
} as const;

export type RegionType = typeof RegionType[keyof typeof RegionType];


export const ResponseEnum = {
    Failure: 'Failure',
    Success: 'Success'
} as const;

export type ResponseEnum = typeof ResponseEnum[keyof typeof ResponseEnum];


export const ShopFilter = {
    NoFilter: 'NoFilter',
    NoLCC: 'NoLCC',
    NonStop: 'NonStop',
    NonStopNoLCC: 'NonStopNoLCC',
    ShortLayover: 'ShortLayover',
    ShortLayoverNoLCC: 'ShortLayoverNoLCC'
} as const;

export type ShopFilter = typeof ShopFilter[keyof typeof ShopFilter];


export interface Sms {
    'MessageMethod'?: MessageMethodEnum;
}


export interface TrackingProperties {
    'properties'?: any;
    'encryptedProperties'?: string;
}
export interface TripContext {
    'airports': { [key: string]: Airport; };
    'airlines': { [key: string]: Airline; };
    'cities': { [key: string]: City; };
}
export interface UpdateWatchAlertRequest {
    'key': AlertKey;
    'method': MessageMethod;
}
export interface WatchAlertView {
    'method': MessageMethod;
    'passengers': { [key: string]: number; };
    'recommendation': Recommendation;
    'attribution'?: any;
    'key': AlertKey;
    'id': string;
    'priceDropProtection': PriceDropProtection;
}


export interface WatchAlertViews {
    'watches': Array<WatchAlertView>;
    'tripContext': TripContext;
}
/**
 * @type WatchAlertViewsResponse
 * @export
 */
export type WatchAlertViewsResponse = { Response: 'Failure' } & Failure | { Response: 'Success' } & WatchAlertViewsSuccess;

export interface WatchAlertViewsSuccess {
    'value': WatchAlertViews;
    'Response': ResponseEnum;
}


export interface WebLinks {
    'changeCancelPolicy'?: string;
    'otherFee'?: string;
    'checkInPolicy'?: string;
    'wifiFee'?: string;
    'homePage'?: string;
    'baggageFees'?: string;
    'seatUpgrade'?: string;
    'manageBooking'?: string;
    'seatSelection'?: string;
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a Watch Alert
         * @param {CreateWatchAlertRequest} createWatchAlertRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AlertWatchCreatePost: async (createWatchAlertRequest: CreateWatchAlertRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createWatchAlertRequest' is not null or undefined
            assertParamExists('apiV0AlertWatchCreatePost', 'createWatchAlertRequest', createWatchAlertRequest)
            const localVarPath = `/api/v0/alert/watch/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWatchAlertRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a given watch alert
         * @param {DeleteWatchAlertRequest} deleteWatchAlertRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AlertWatchDeletePost: async (deleteWatchAlertRequest: DeleteWatchAlertRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteWatchAlertRequest' is not null or undefined
            assertParamExists('apiV0AlertWatchDeletePost', 'deleteWatchAlertRequest', deleteWatchAlertRequest)
            const localVarPath = `/api/v0/alert/watch/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteWatchAlertRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch details for a given Watch Key
         * @param {GetWatchAlertDetailsRequest} getWatchAlertDetailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AlertWatchDetailsPost: async (getWatchAlertDetailsRequest: GetWatchAlertDetailsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getWatchAlertDetailsRequest' is not null or undefined
            assertParamExists('apiV0AlertWatchDetailsPost', 'getWatchAlertDetailsRequest', getWatchAlertDetailsRequest)
            const localVarPath = `/api/v0/alert/watch/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getWatchAlertDetailsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch current watches
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AlertWatchListPut: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/alert/watch/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a given watch alert
         * @param {UpdateWatchAlertRequest} updateWatchAlertRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AlertWatchUpdatePost: async (updateWatchAlertRequest: UpdateWatchAlertRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateWatchAlertRequest' is not null or undefined
            assertParamExists('apiV0AlertWatchUpdatePost', 'updateWatchAlertRequest', updateWatchAlertRequest)
            const localVarPath = `/api/v0/alert/watch/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWatchAlertRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a Watch Alert
         * @param {CreateWatchAlertRequest} createWatchAlertRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0AlertWatchCreatePost(createWatchAlertRequest: CreateWatchAlertRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0AlertWatchCreatePost(createWatchAlertRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a given watch alert
         * @param {DeleteWatchAlertRequest} deleteWatchAlertRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0AlertWatchDeletePost(deleteWatchAlertRequest: DeleteWatchAlertRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0AlertWatchDeletePost(deleteWatchAlertRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch details for a given Watch Key
         * @param {GetWatchAlertDetailsRequest} getWatchAlertDetailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0AlertWatchDetailsPost(getWatchAlertDetailsRequest: GetWatchAlertDetailsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetWatchAlertDetailsResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0AlertWatchDetailsPost(getWatchAlertDetailsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch current watches
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0AlertWatchListPut(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WatchAlertViewsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0AlertWatchListPut(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a given watch alert
         * @param {UpdateWatchAlertRequest} updateWatchAlertRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0AlertWatchUpdatePost(updateWatchAlertRequest: UpdateWatchAlertRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0AlertWatchUpdatePost(updateWatchAlertRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Create a Watch Alert
         * @param {CreateWatchAlertRequest} createWatchAlertRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AlertWatchCreatePost(createWatchAlertRequest: CreateWatchAlertRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0AlertWatchCreatePost(createWatchAlertRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a given watch alert
         * @param {DeleteWatchAlertRequest} deleteWatchAlertRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AlertWatchDeletePost(deleteWatchAlertRequest: DeleteWatchAlertRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0AlertWatchDeletePost(deleteWatchAlertRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch details for a given Watch Key
         * @param {GetWatchAlertDetailsRequest} getWatchAlertDetailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AlertWatchDetailsPost(getWatchAlertDetailsRequest: GetWatchAlertDetailsRequest, options?: any): AxiosPromise<GetWatchAlertDetailsResponseResponse> {
            return localVarFp.apiV0AlertWatchDetailsPost(getWatchAlertDetailsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch current watches
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AlertWatchListPut(options?: any): AxiosPromise<WatchAlertViewsResponse> {
            return localVarFp.apiV0AlertWatchListPut(options).then((request) => request(axios, basePath));
        },
        /**
         * Update a given watch alert
         * @param {UpdateWatchAlertRequest} updateWatchAlertRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AlertWatchUpdatePost(updateWatchAlertRequest: UpdateWatchAlertRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0AlertWatchUpdatePost(updateWatchAlertRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * Create a Watch Alert
     * @param {CreateWatchAlertRequest} createWatchAlertRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0AlertWatchCreatePost(createWatchAlertRequest: CreateWatchAlertRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0AlertWatchCreatePost(createWatchAlertRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a given watch alert
     * @param {DeleteWatchAlertRequest} deleteWatchAlertRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0AlertWatchDeletePost(deleteWatchAlertRequest: DeleteWatchAlertRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0AlertWatchDeletePost(deleteWatchAlertRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch details for a given Watch Key
     * @param {GetWatchAlertDetailsRequest} getWatchAlertDetailsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0AlertWatchDetailsPost(getWatchAlertDetailsRequest: GetWatchAlertDetailsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0AlertWatchDetailsPost(getWatchAlertDetailsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch current watches
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0AlertWatchListPut(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0AlertWatchListPut(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a given watch alert
     * @param {UpdateWatchAlertRequest} updateWatchAlertRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0AlertWatchUpdatePost(updateWatchAlertRequest: UpdateWatchAlertRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0AlertWatchUpdatePost(updateWatchAlertRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


